<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
										{{ $t('titles.courseTeachers') }}</v-card-title
									>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="courseTeachersTable.additionalFilters"
										:default-sort="courseTeachersTable.defaultSort"
										:excel="true"
										:fields="courseTeachersTable.headers"
										:header-selection-key="'course-teachers-headers'"
										:height="courseTeachersTable.height"
										:total-records="courseTeachersTable.total"
										@excel="excelExport"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in courseTeachersTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
											@contextmenu.prevent="redirect(props.item.planned_course_id)"
										>
											<td
												v-if="courseTeachersTable.selectedHeaders.includes('first_name')"
												@click="redirect(item.teacher.id)"
											>
												{{ item.teacher.first_name }}
											</td>
											<td
												v-if="courseTeachersTable.selectedHeaders.includes('last_name')"
												@click="redirect(item.teacher.id)"
											>
												{{ item.teacher.last_name }}
											</td>
											<td
												v-if="courseTeachersTable.selectedHeaders.includes('phone')"
												@click="redirect(item.teacher.id)"
											>
												{{ item.teacher.phone }}
											</td>
											<td
												v-if="courseTeachersTable.selectedHeaders.includes('email')"
												@click="redirect(item.teacher.id)"
											>
												{{ item.teacher.email }}
											</td>
											<td
												v-if="courseTeachersTable.selectedHeaders.includes('office')"
												@click="redirect(item.teacher.id)"
											>
												{{ item.office.name }}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'TeachersCourses',
	components: { TheTable },
	props: {
		teachersId: [String, Number],
	},
	data: function () {
		return {
			courseTeachersTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.firstName'),
						value: 'first_name',
						type: '',
						sortable: true,
						allowFilter: true,
					},
					{
						text: this.$t('fields.lastName'),
						value: 'last_name',
						type: '',
						sortable: true,
						allowFilter: true,
					},
					{
						text: this.$t('fields.phone'),
						value: 'phone',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.email'),
						value: 'email',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.office'),
						value: 'office',
						type: '',
						sortable: true,
						allowFilter: true,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'first_name',
					descending: true,
				},
			},
		};
	},
	methods: {
		selectHeaders(headers) {
			this.courseTeachersTable.selectedHeaders = headers;
		},
		redirect(id) {
			this.$router.push('/teachers/' + id);
		},
		reloadData(request) {
			this.courseTeachersTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'course-teachers/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.courseTeachersTable.items = data.items;
						vm.courseTeachersTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.courseTeachersTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'course-teachers/' + this.$route.params.id,
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/course-teachers', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.courseTeachersTable.height = window.innerHeight - 330 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
